import Text from "shared/components/data-display/text/Text";
import BaseButton from "shared/components/inputs/button/BaseButton";
import { COLOR_VALUES } from "shared/config/colors";
import styled from "styled-components";
import { TertiaryButtonStyle } from "shared/components/inputs/button/Button.styles";

export const StyledQuaternaryButton = styled(BaseButton)`
    color: ${COLOR_VALUES.Black} !important; /* !important to override css reboot */
    text-decoration: none !important; /* !important to override css reboot */
    padding: 2px;
    min-height: 20px;
    border: 1px solid ${COLOR_VALUES.Gray_6};

    ${TertiaryButtonStyle}

    gap: 0;
    border-radius: 10px;

    &:not(:disabled) {
        &:hover {
            color: ${COLOR_VALUES.Gray_2} !important;
            background: ${COLOR_VALUES.Gray_7};
            border-color: ${COLOR_VALUES.Gray_6};
        }

        &:active,
        &:focus-visible {
            border-color: transparent;
        }
    }

    &:disabled {
        background: ${COLOR_VALUES.Gray_8};
        border-color: ${COLOR_VALUES.Gray_6};
    }
`;

export const StyledText = styled(Text)`
    padding-left: 4px;
    padding-right: 4px;
    color: ${(props) => COLOR_VALUES[props.$color] ?? ""};
`;

export const InlineBlockToPreventTooltipDisabledButtonError = styled.div`
    display: inline-block;
`;
